import type { Directive, VNode } from 'vue'

interface CustomVNode extends VNode {
  _clickOutsideListener: (event: Event) => void
}

export const ClickOutside: Directive<HTMLElement, (e: Event) => void> = {
  beforeMount(el, binding, vnode) {
    if (!import.meta.client) return
    const callback = binding.value
    const handler = (event: Event) => {
      if (document.contains(el) && !el.contains(event.target as HTMLElement)) {
        callback(event)
      }
    }
    const node = vnode as CustomVNode
    node._clickOutsideListener = handler
    document.addEventListener('click', node._clickOutsideListener, true)
  },
  unmounted(el, _, vnode) {
    if (!import.meta.client) return
    const node = vnode as CustomVNode
    document.removeEventListener('click', node._clickOutsideListener, true)
  },
}
